"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const outline_icons_1 = require("outline-icons");
const SSR = typeof window === "undefined";
const isMac = !SSR && window.navigator.platform === "MacIntel";
const mod = isMac ? "⌘" : "ctrl";
function blockMenuItems(dictionary) {
    return [
        {
            name: "heading",
            title: dictionary.h1,
            icon: outline_icons_1.Heading1Icon,
            shortcut: "#",
            attrs: { level: 1 },
        },
        {
            name: "heading",
            title: dictionary.h2,
            icon: outline_icons_1.Heading2Icon,
            shortcut: "##",
            attrs: { level: 2 },
        },
        {
            name: "heading",
            title: dictionary.h3,
            icon: outline_icons_1.Heading3Icon,
            shortcut: "###",
            attrs: { level: 3 },
        },
        {
            name: "separator",
        },
        {
            name: "link",
            title: dictionary.link,
            icon: outline_icons_1.LinkIcon,
            shortcut: `${mod} K`,
        },
        {
            name: "blockquote",
            title: dictionary.quote,
            icon: outline_icons_1.BlockQuoteIcon,
            shortcut: `<`,
        },
        {
            name: "code_block",
            title: dictionary.codeBlock,
            icon: outline_icons_1.CodeIcon,
            shortcut: "```",
        },
        {
            name: "separator",
        },
        {
            name: "bullet_list",
            title: dictionary.bulletList,
            icon: outline_icons_1.BulletedListIcon,
            shortcut: "-",
        },
        {
            name: "ordered_list",
            title: dictionary.orderedList,
            icon: outline_icons_1.OrderedListIcon,
            shortcut: "1.",
        },
        {
            name: "checkbox_list",
            title: dictionary.checkboxList,
            icon: outline_icons_1.TodoListIcon,
        },
        {
            name: "separator",
        },
        {
            name: "table",
            title: dictionary.table,
            icon: outline_icons_1.TableIcon,
            attrs: { rowsCount: 3, colsCount: 3 },
        },
        {
            name: "hr",
            title: dictionary.hr,
            icon: outline_icons_1.HorizontalRuleIcon,
            shortcut: "---",
        },
        {
            name: "hr",
            title: dictionary.pageBreak,
            icon: outline_icons_1.PageBreakIcon,
            shortcut: "***",
            attrs: { markup: "***" },
        },
        {
            name: "image",
            title: dictionary.image,
            icon: outline_icons_1.ImageIcon,
        },
        {
            name: "separator",
        },
        {
            name: "container_notice",
            title: dictionary.infoNotice,
            icon: outline_icons_1.InfoIcon,
            attrs: { style: "info" },
        },
        {
            name: "container_notice",
            title: dictionary.warningNotice,
            icon: outline_icons_1.WarningIcon,
            attrs: { style: "warning" },
        },
        {
            name: "container_notice",
            title: dictionary.tipNotice,
            icon: outline_icons_1.StarredIcon,
            attrs: { style: "tip" },
        },
    ];
}
exports.default = blockMenuItems;
